// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-l_gL","galleryItem_borderTopRadius":"c-l_gM","galleryItem__image":"c-l_gN","galleryItem__image_withBlur":"c-l_gO"};